import React from 'react';
import styles from './InventoryTable.module.css';
import { VelocityBadge } from './VelocityBadge';
import { InventoryItem } from '../inventoryTypes';

interface InventoryTableProps {
  items: InventoryItem[];
}

export const InventoryTable: React.FC<InventoryTableProps> = ({ items }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.thProduct}>PRODUCT</th>
            <th>CATEGORY</th>
            <th>VELOCITY</th>
            <th className={styles.thRight}>UNITS IN HAND</th>
            <th className={styles.thRight}>DAYS UNTIL REORD</th>
            <th className={styles.thRight}>TURNOVER</th>
            <th className={styles.thRight}>STOCK/UNIT</th>
            <th className={styles.thRight}>EXPIRY</th>
            <th className={styles.thRight}>PROFIT/UNIT</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className={styles.row}>
              <td className={styles.productCell}>
                <span className={styles.productName}>{item.productName}</span>
                <span className={styles.sku}>{item.sku}{item.barcode ? ` · ${item.barcode}` : ''}</span>
              </td>
              <td className={styles.categoryCell}>{item.category}</td>
              <td>
                <VelocityBadge velocity={item.velocity} />
              </td>
              <td className={styles.numericCell}>
                {item.unitsInHand.toLocaleString()}
              </td>
              <td className={styles.numericCell}>
                <span className={styles.daysValue}>{item.daysUntilReorder}</span>
                <span className={styles.daysLabel}>days</span>
              </td>
              <td className={styles.numericCell}>
                <span className={styles.turnoverValue}>{item.turnover.toFixed(1)}</span>
                <span className={styles.turnoverLabel}>x</span>
              </td>
              <td className={styles.numericCell}>
                {item.stockPerUnit.toLocaleString()}
              </td>
              <td className={`${styles.numericCell} ${styles[item.expiryStatus]}`}>
                <span className={styles.expiryDate}>{item.expiry}</span>
                {item.expiryStatus === 'expiring' && (
                  <span className={styles.expiryLabel}>Expiring</span>
                )}
                {item.expiryStatus === 'exp-soon' && (
                  <span className={styles.expSoonLabel}>Exp Soon</span>
                )}
              </td>
              <td className={styles.numericCell}>
                <span className={styles.profitValue}>${item.profitPerUnit.toFixed(2)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
